export const MB = 1024 * 1024;
